export const actionTypes = {
  ET_LOADING_START: "ET_LOADING_START",
  ET_LOADING_STOP: "ET_LOADING_STOP",
  ET_SHOW_LIST: "ET_SHOW_LIST",
  ET_ADD_SUCCESS: "ET_ADD_SUCCESS",
  ET_UPDATE_SUCCESS: "ET_UPDATE_SUCCESS",
  ET_DELETE_SOFT: "ET_DELETE_SOFT",
};
